import { transform } from 'framer-motion';
import { calculateSpaceScale } from 'utopia-core';

import { MEDIA_QUERIES } from '@/utils/theme/sharedStyles';

import { type BlogPageData, type PageContext } from './types';

export function getCategoryColor(category: string) {
  switch (category.toLowerCase()) {
    case 'data teams':
      return '#CDA849';
    case 'data':
      return '#F5C0C0';
    case 'security':
      return '#B55E60';
    case 'product':
      return '#A477B2';
    case 'design':
      return '#859850';
    case 'engineering':
      return '#67B69E';
    case 'friends of data':
      return '#8E7CD8';
    case 'company':
      return '#FFFFFF';
    case 'further reading':
      return '#717A94';

    default:
      return '#000000';
  }
}

export function getCategoryOrder(category: string) {
  const categories = [
    'product',
    'company',
    'data',
    'security',
    'data teams',
    'design',
    'engineering',
    'friends of data',
    'further reading'
  ];

  const order = categories.findIndex(c => c === category.toLocaleLowerCase());
  return order >= 0 ? order : categories.length - 2;
}

export function orderCategories(
  categories: BlogPageData['allContentfulBlogCategory']['nodes']
) {
  return categories.sort(
    (a, b) => getCategoryOrder(a.name) - getCategoryOrder(b.name)
  );
}

export function getNormalizedReadingTime(
  readingTime: PageContext['readingTime'][string] | null
) {
  return transform(Math.floor(readingTime?.minutes || 0), [0, 15], [0, 1]);
}

export function generateFluidPxScale(min: number, max: number) {
  const scale = calculateSpaceScale({
    minWidth: MEDIA_QUERIES.MOBILE,
    maxWidth: MEDIA_QUERIES.EXTRA_LARGE,
    minSize: min,
    maxSize: max
  });

  return scale.sizes[0].clampPx;
}
